import React, { useState } from 'react';
import LockIcon from '@material-ui/icons/Lock';
import Divider from '@material-ui/core/Divider';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';

const AdminCredentials = ({email,pass}) => {

    const { password,setPassword } = pass;
    const { userEmail, setUserEmail} = email;
    const [showPassword,setShowPassword] = useState(false);

    return (
        <div className="admin-credentials">
            <p>
            In order to edit your Snapboard you need to register by providing your email and password. 
            In the future you can use this email and password to log into the Snapfix app and edit your Snapboard.
            </p>
            <div className="divider-container">
                <span>
                    <LockIcon /> ADMIN CREDENTIALS 
                </span>

                <Divider variant='middle' />
            </div>

            <div className="text-fields">
                <div className="email-field-container">
                    <h4>Email</h4>
                    <TextField 
                        id="outlined-basic" 
                        placeholder="name@YourHotel.com" 
                        variant="outlined"
                        type="text" 
                        value={userEmail}
                        onChange={(e) => setUserEmail(e.currentTarget.value)}
                    />
                </div>
                <div className="password-field-container">
                    <div className="h4">
                        <h4>PASSWORD</h4>
                    </div>
                    <FormControl variant="outlined">
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={!showPassword ? 'password' : 'text'}
                            placeholder="Password"
                            value={password}
                            onChange={(e)=> setPassword(e.currentTarget.value)}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword(!showPassword)}
                                        onMouseDown={(event) => event.preventDefault()}
                                        edge="end"
                                    >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                </div>
            </div>
        </div>
    )
};

export default AdminCredentials;